import { render } from "./PayinBalanceLimitSection.vue?vue&type=template&id=95dfc038&ts=true"
import script from "./PayinBalanceLimitSection.vue?vue&type=script&lang=ts"
export * from "./PayinBalanceLimitSection.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__